import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2';
import BackNavbar from '../../../../ReusableBlocks/Navbar';
import FooterBlock from '../../../../ReusableBlocks/FooterBlock';
import ProfileDummy from '../../../../Images/profile-dummy.png';
import IndivudalReportImage from '../../../../Images/ind-Report.png'
import RegionalReportImage from '../../../../Images/Reg-report.png'
import TopNarratives from '../../../../Images/top-narrtives.png'
import LoadingScreen from '../../../../ReusableBlocks/LoadingScreen';

import BarChartHalf from './BarChartHalf'
import LineChartHalf from './LineChartHalf'
import LearningHubSection from './learningHubData'

import { useDispatch, useSelector } from 'react-redux';
import { fetchSEAnalyticsFuc } from '../../../../Redux/Dashboard/External/Analytics/SEAnalytics/Action/SEAnalyticsAction';
import '../../../../Styles/LeadershipConsole.css';



const User_Analytics = () => {


  const dispatch = useDispatch();
  const [containerClass, setContainerClass] = useState('container');

  const isLoading = useSelector(state => state.SEAnalytics?.loading);
  const errorMessage = useSelector(state => state.SEAnalytics?.error);
  const result = useSelector(state => state.SEAnalytics?.result);


  const topNarratives = result['top-narratives']?.narratives;


  const individualWeekReport = result['individual-week-report'];
  const individualMonthReport = result['individual-month-report'];

  const regionMonthReport = result['region-month-report'];
  const regionWeekReport = result['region-week-report'];
  console.log(result['learning-hub-status']);

  const learningHubData = result['learning-hub-status']


  useEffect(() => {
    dispatch(fetchSEAnalyticsFuc());
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setContainerClass(window.innerWidth < 992 ? 'container-fluid' : 'container');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetching Error 
  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessage]);









const count = 500000;





  return (
    <>
      {isLoading && <LoadingScreen text="Loading Analytics" />}
      <BackNavbar />

      <div className="manager-console-background lead-dash-page">
        <section>
          <div className="leadership-console-hero-section">
            <div className="container">
              <div className="learning-hub-micro-certs-her-content">
                <h6 className="learning-hub-micro-certs-her-content-h1">
                  Individual Analytics
                </h6>
              </div>
            </div>
          </div>
        </section>

        <div className={`${containerClass} leadership-analytics-container`}>
        <div className="my-5">
          <img src={TopNarratives} className="tag-image" alt="Top Narratives" />
          <br />
          <br />
          <div className="row">
            {topNarratives?.slice(0, 3).map((item, index) => (
              <div key={index} className="col-md-4">
                <div className="ind-anl-card p-3 shadow-sm d-flex align-items-center justify-content-between flex-row">
                  <span className="ind-anl-card-title mb-0">{item.title}</span>
                  <div className="ind-anl-card-circle d-flex align-items-center justify-content-center">
                    {item.count > 9999 ? `${item.count.toString().slice(0, 4)}+` : item.count}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Individual Report */}
        <section>
          <div>
            <img src={IndivudalReportImage} className='tag-image' />
            <div class="row row-cols-1 row-cols-md-2">
              <div class="col mb-4">
                <br></br>
                <BarChartHalf
                  // year={year} 
                  data={individualMonthReport}
                  title="Your Monthly Top Narratives"
                />
              </div>

              <div class="col mb-4">
                <div>
                  <br></br>
                  <LineChartHalf data={individualWeekReport}
                    // tagline="Weekly Report of Jan 2024 - Demos Run by Team Members" 
                    title="Your Weekly Demo Volume"
                  />
                </div>

              </div>



            </div>
          </div>
        </section>
        {/* -----XXX---- */}




        {/* Regional Report */}
        <section>
          <div>
            <img src={RegionalReportImage} className='tag-image' />
            <div class="row row-cols-1 row-cols-md-2">
              <div class="col mb-4">
                <br></br>
                <BarChartHalf
                  // year={year} 
                  data={regionMonthReport}
                  title="Monthly Top Narratives in Your Region"
                />
              </div>

              <div class="col mb-4">
                <br></br>
                <LineChartHalf data={regionWeekReport}
                  // tagline="Weekly Report of Jan 2024 - Demos Run by Team Members" 
                  title="Weekly Demo Volume in Your Region"
                />
              </div>
            </div>
          </div>
        </section>
        {/* ---XX--  */}





        <LearningHubSection learningHubData={learningHubData} />
        </div>
      </div>


    </>
  )
}

export default User_Analytics;
